module.exports = __webpack_public_path__ + "static/media/facebook-dark-blue.81955b5c.svg";